Ext.define('SA.HistogramPartStyles', {
    singleton: true,

    styles: {
        chartTitle: {
            color: '#2c3852',
            fontSize: '18px',
            fontWeight: '600',
            lineHeight: '20px',
            textAnchor: 'middle'
        },

        frame: {
            fill: 'none',
            stroke: '#aaafb9'
        },

        gridLine: {
            stroke: '#ddd'
        },

        xLabel: {
            dominantBaseline: 'central',
            fill: '#727a8b',
            fontSize: '12px',
            textAnchor: 'end'
        },

        xTitle: {
            color: '#2c3852',
            fontSize: '14px',
            lineHeight: '18px',
            textAnchor: 'middle'
        },

        yLabel: {
            dominantBaseline: 'central',
            fill: '#727a8b',
            fontSize: '12px',
            textAnchor: 'end'
        },

        yTitle: {
            dominantBaseline: 'ideographic',
            fill: '#2c3852',
            fontSize: '14px',
            textAnchor: 'middle'
        }
    },

    get(partName) {
        var style = this.styles[partName],
            isText = /title|label/i.test(partName),
            commonTextStyle = {
                fontFamily: 'LatoLatinWeb, Lato', 
                letterSpacing: '0.2px'
            };

        return isText ? {...style, ...commonTextStyle} : style;
    }
});